import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button,Spinner, Alert, Card ,Table} from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { getAllProduct } from "../product/productAction";
import { getAllServiceType } from "../serviceType/serviceTypeAction";
import { getAllTourType } from "../tourTypes/TourTypeAction";
import { getAllMainSubProduct } from "../subproduct/subproductAction";
import { useParams, useNavigate, Link } from 'react-router-dom';
import { productcommissionModification, getSingleProductCommission,productcommissionApproved ,productcommissionRejected} from "../commission/commissionAction";
import Swal from 'sweetalert2';
import { FaEdit, FaTrash, FaPlus, FaEye,FaCheck, FaBan,FaPaperPlane, FaArrowLeft } from 'react-icons/fa';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { DefaultEditor } from 'react-simple-wysiwyg';
import { TextField } from '@mui/material';

const Modifycommission = () => {
  const dispatch = useDispatch();
  const { name } = useParams();
  const { idd } = useParams();
  const navigate = useNavigate();
  const ProductRef = useRef(null);
  const [product, setProduct] = useState("");
  const [productid,setProductid]= useState('');
  const [tourtypeid,setTourtypeid]= useState('');
  const [servicetypeid,setServicetypeid]= useState('');
  const { products } = useSelector((state) => state.productList);
  const { serviceType } = useSelector((state) => state.serviceTypiesList);
  const { tourType } = useSelector((state) => state.tourTypesList);
  const { subproducts2 } = useSelector((state) => state.subproductList);
//   const [remarkshow, setRemarkshow] = useState({});
const [remarks, setRemarks] = useState([]);
console.log("remarks",remarks)
  const [isAlive,setIsAlive] = useState(false);
  const [productdescription,setProductdescription]= useState('');


  const [subproducts22, setSubproducts22] = useState([]);
  const [commissiondata, setCommissionData] = useState({
    id:"",
    commission:"",
    commission_type:"",
    serviceTypeId:"",
    product_id:"",
    status:"",
  });


  const [commissiondata2, setCommissionData2] = useState([]);
  const [allCommission, setAllCommission] = useState("");
  const [applyToAll, setApplyToAll] = useState(false);
  const productcommissionData = useSelector((state) => state.productcommissionList);




  
  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadProductCommission(idd);
      return () => setIsAlive(false);
    }
  }, [isAlive]);

  useEffect(() => { 
   
  
    if (isAlive) {
        loadProductCommission(idd);
        dispatch(getSingleProductCommission(idd));
        setIsAlive(false);
      }
    }, [isAlive]);
  



     const { register, handleSubmit, formState: { errors } } = useForm();

   

     function loadProductCommission(idd) {
      dispatch(getSingleProductCommission(idd));
    
      const commissionDataArray = cData.map((data) => ({
        id: data.id,
        commission: data.commission,
        commissiontype: data.commission_type,
        product_id: data.product_id,
        serviceTypeId: data.service_type_id,
        status: data.status,
        subproduct_name : data.subproduct_name
      }));
    
      setCommissionData(commissionDataArray);
    }
    
    


  
   const cData = JSON.parse(JSON.stringify(productcommissionData.commissions));
    console.log("cData",cData)
  //  const handleOnChange = e => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   // console.log('name '+name); 
  //   //console.log('value '+value); 
  //   setCommissionData({ ...commissiondata, [name]: value });
  //   /* setRole(prevState => ({
  //     role:{
  //       ...prevState.role,
  //       [name]: value
  //     }
  //   })); */
  // };

  const onProductApprove = (id, e) => {
    e.preventDefault();
    Swal.fire({
        title: 'Are you sure want to approve the commission?',
        showDenyButton: true,
        icon:'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        }
      }).then((result) => {
        if (result.isConfirmed) {
            dispatch(productcommissionApproved(id));
            dispatch(getSingleProductCommission(id));
          
            
            setIsAlive(true)
      
              
          Swal.fire('Approved Successfully!', '', 'success')
        } else if (result.isDenied) {
          Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
        }
      })


}


const onProductReject = (id, subproducts, e,index) => {
    e.preventDefault();
    Swal.fire({
        title: 'Are you sure want to reject the commission?',
        showDenyButton: true,
        icon:'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        }
      }).then((result) => {
        if (result.isConfirmed) {
         
            const updatedRemarks = [...remarks];

        // Set the value at the specific index to an empty string
        updatedRemarks[index] = '';

        // Update the remarks state
        setRemarks(updatedRemarks);
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', 'Your Data is safe', 'info');
      }
    });
  };
  const onRemarksChange = (index, e) => {
    // Create a copy of the remarks array
    const updatedRemarks = [...remarks];

    // Set the value at the specific index to the new value
    updatedRemarks[index] = e.target.value;

    // Update the remarks state
    setRemarks(updatedRemarks);
  };


  const handleOnChange = (index, e) => {
    const name = e.target.name;
    const value = e.target.value;
  
    // Update the specific item in the commissiondata array
    const updatedCommissionData = commissiondata.map((item, idx) => {
      if (idx === index) {
        return { ...item, [name]: value };
      }
      return item;
    });
  
    setCommissionData(updatedCommissionData);
  };
  
  


  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getAllServiceType());
    dispatch(getAllMainSubProduct());
    
  }, []);

 
  const handleApplyToAllChange = (event) => {
    const checked = event.target.checked;
    const newSubproducts = commissiondata.map((subproduct) => ({
      ...subproduct,
      commission: checked ? allCommission : subproduct.commission,
    }));
    setCommissionData(newSubproducts);
    setApplyToAll(checked);
  };

  const handleSubproductCommissionChange = (index, newCommission) => {
    const newSubproducts = [...commissiondata];
    newSubproducts[index].commission = newCommission;
    
    setCommissionData(newSubproducts);
    setApplyToAll(false);
  };
  console.log("commissiondata:", commissiondata);
  console.log("productcommissionData:", productcommissionData);



  const handleOnSubmit = (id,event,index) => {
    event.preventDefault();
    // Save the commission data to the database
    const finalremark = remarks.filter(obj => obj !== undefined);
    console.log("finalremark",finalremark)
    const commissionUpdation2 = {
        id, finalremark
      };

    dispatch(productcommissionRejected(commissionUpdation2));
    const updatedRemarks = [...remarks];

    // Set the value at the specific index to the new value
    updatedRemarks[index] = undefined;

    // Update the remarks state
    setRemarks(updatedRemarks);
    setIsAlive(true);
    Swal.fire({
      title: 'Rejected!',
      text: 'Remark Sent Successfully',
      icon: 'success',
      confirmButtonText: 'Okay'
    })
  
    

    
  };

  return (
    <Container className="my-4 mx-4 container-xl ">

<Card  style={{marginLeft:'100px',marginTop:'-60px'}}>

      <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Approval</h4></Card.Header>
      <Card.Body>
          <div>
            <Link to="/approvalCommissionList"><span className="badge bg-success" style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' }}><FaArrowLeft />&nbsp;Go Back</span></Link>

          </div>
          <br />
        
        <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off"> {/* handleOnSubmit() */}

          <Row className="mb-3">
          
           
            
       
    <div>
    
   
         <br />
            <br />
   
          <Table striped bordered hover>
        <thead>
          <tr>
            <th>Sub Product Name</th>
            <th>Commission Type</th>
            <th>Commission Amount</th>
            <th></th>
            {/* <th></th> */}
          </tr>
        </thead>

        <tbody>
        {cData.filter(obj => obj.status == "Pending") && cData.filter(obj => obj.status == "Pending").length > 0 ?( cData.filter(obj => obj.status == "Pending").map((subproduct2, index) => (
    <tr key={index}>
      <td>{subproduct2.subproduct_name}</td>
      <td>
        <Form.Group as={Col} controlId="formGridStatus">
          <Form.Select
            required
            name="status"
            disabled
            value={subproduct2.commissiontype}
            onChange={(e) => handleOnChange(index, e)}
          >
            <option value="">Choose..</option>
            <option
              value="Percentage"
              selected={subproduct2.commission_type === "Percentage" ? true : false}
            >
              Percentage
            </option>
            <option
              value="Fixed"
              selected={subproduct2.commission_type === "Fixed" ? true : false}
            >
              Fixed
            </option>
          </Form.Select>
        </Form.Group>
      </td>
      <td>
        <input
          type="number"
          name="commission"
          min="0"
          max="100"
          disabled
          style={{ width: "220px" }}
          value={commissiondata?.commission ? commissiondata?.commission :subproduct2.commission}
          autoComplete="off"
          placeholder="Enter The Commission"
          {...register("commission", { required: true, maxLength: 10 })}
          onChange={(e) => handleOnChange(index, e)}
        />
      </td>
      <td><>{subproduct2.status == "Approved" ? <><Tooltip title="Approve"><Button className="btn btn-sm btn-success">Approved</Button></Tooltip></> : subproduct2.status == "Rejected" ? <><Tooltip title="Approve"><Button className="btn btn-sm btn-danger">Rejected</Button></Tooltip></>: <><Tooltip title="Approve"><Button className="btn btn-sm btn-success" onClick={(e) => onProductApprove(subproduct2.id, e)}><FaCheck className='fwcolor' /></Button></Tooltip>&nbsp;<Tooltip title="Reject"><Button className="btn btn-sm btn-danger"   onClick={(e) => onProductReject(subproduct2.id,subproduct2, e,index)} ><FaBan className='fwcolor' /></Button></Tooltip></>}   </></td>
      {/* {console.log("remarkshow[subproduct.id]2 ",remarkshow[subproduct2.id] )} */}
     
      {remarks[index] !== undefined && (
        <td>  <textarea rows="5"  style={{width:"140px",height:"60px"}}   ref={ProductRef} name="productdescription" {...register("productdescription", { required: true, mixLength: 3 })}
        onChange={(e) => onRemarksChange(index, e)}
          ></textarea>&nbsp;<Button className='btn btn-sm btn-primary' style={{fontSize:"9px",marginTop:"-20px",backgroundColor:'#1c345e'}} onClick={(event) => handleOnSubmit(subproduct2.id,event,index)}><FaPaperPlane  className='fwcolor' /></Button></td>
          )}   </tr>
  )) ): ( <><tr>
    <td colSpan="4">
      <br />
      <h4 style={{ textAlign: "center", color: "red" }}>
        No Data Found For Approval..
      </h4>
    </td>
  </tr></>)
}


</tbody>

      </Table>
    </div>
  
          </Row>
         

        </Form>
      </Card.Body>
    </Card>

  </Container>
  );
};

export default Modifycommission;
